import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { CentreReviewsResponse } from './types'

export function getCentreEndOfJourneyReviews(centerId: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getEndOfJourneyReviews.url, { id: centerId }))
    .get<CentreReviewsResponse>()
}
